@if (initialized) {
    <div class="mt-4">
        <div class="grid">

            <!-- Widget Display -->
            <div class="col-12">
                <ng-container [ngSwitch]="activeNavigationItem?.action">

                    <mvs-widget
                            *ngSwitchCase="'RoleData'"
                            [widgetData]="roleWidgetData"
                    ></mvs-widget>

                    <mvs-widget
                            *ngSwitchCase="'Module'"
                            [widgetData]="roleAuthModuleWidget"
                    ></mvs-widget>
                    <mvs-widget
                            *ngSwitchCase="'ObjectType'"
                            [widgetData]="roleAuthObjectTypeWidget"
                    ></mvs-widget>
                    <mvs-widget
                            *ngSwitchCase="'QueryStart'"
                            [widgetData]="roleAuthQueryStartWidget"
                    ></mvs-widget>
                    <mvs-widget
                            *ngSwitchCase="'Contract'"
                            [widgetData]="roleAuthContractWidget"
                    ></mvs-widget>
                    <div *ngSwitchCase="'Customer'">

                        <div class="grid">
                            <div class="col-4">

                                <mvs-widget
                                        [widgetData]="roleAuthCustomerWidget"
                                        (onObjectSelect)="handleObjectSelect($event)"
                                ></mvs-widget>
                            </div>
                            <div class="col-8">

                                @if (roleAuthCustomerRegionWidget) {
                                    <mvs-widget
                                            [widgetData]="roleAuthCustomerRegionWidget"
                                    ></mvs-widget>
                                }

                                @if (roleAuthCustomerTypeWidget) {
                                    <mvs-widget
                                            [widgetData]="roleAuthCustomerTypeWidget"
                                    ></mvs-widget>
                                }
                            </div>
                        </div>

                    </div>
                    <div *ngSwitchDefault>
                        <mvs-widget
                                [widgetData]="roleAuthModuleWidget"
                        ></mvs-widget>
                    </div>
                </ng-container>
            </div>
        </div>
    </div>

}